import script from "./ai-image-display.vue?vue&type=script&setup=true&lang=ts"
export * from "./ai-image-display.vue?vue&type=script&setup=true&lang=ts"

import "./ai-image-display.vue?vue&type=style&index=0&id=aedda34e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aedda34e"]])

export default __exports__